import React, { Component } from "react";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Card,
  CardBody,
  Label,
  Collapse,
  FormGroup,
  Form,
} from "reactstrap";
import CartTitle from "../CartTitle";
import ImagePreviewComponent from "../ImagePreviewComponent";
import CustomButton from "../CustomButton";
import InputText from "../InputText";
import ImageComponent from "../ImageComponent";

import moment from "moment";

import Slider from "react-slick";
import config from "../../utils/config";
import DesignCard from "../../components/DesignCard";
import Loader from "../../components/Loader";
import get from "lodash/get";

const _ = { get };
var settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
export default class ImageModerationMain extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rejectionReason: "",
      toggleRejectModal: false,
      imageData: null,
      toggleActive: true,
      country: "",
      countryCode: "",
      count: 100,
      stateCode: "",
      state: "",
      page: 0,
      city: "",
      status: "PENDING",
      category: "ride",
      branchId: "",
      branchName: "",
      pageSize: 10,
      previewModal: false,
      previewImage: false,
      imageAndRideDetail: null,
      imageDetail: null,
      slugForRejection: null,
      statusForApproveAndReject: "PENDING",
      activityId: "",
      finalCategory: "ride",
      toggleDeleteModal: false,
      deleteReason: "",
    };
  }

  componentDidMount() {
    let state = this.state;
    let data = {
      status: "PENDING",
      countryCode: "",
      branchId: state.branchId,
      branchName: state.branchId,
      category: "ride",
      activityId: "",
    };
    this.props.handleFetchImageForModeration(data);
    this.handleFetchCountryFromCategory("PENDING", "ride");
  }

  handleFetchCountryFromCategory = (status, category) => {
    const data = {
      status: status,
      category: category,
    };
    this.props.handleFetchImageCountry(data);
  };

  handleChangeStatus = (e) => {
    let newState = { ...this.state };
    newState.status = e.target.value;
    newState.country = "";
    newState.countryCode = "";
    newState.branchId = "";
    newState.activityId = "";
    newState.branchName = "";
    const data = {
      status: e.target.value,
      category: this.state.category,
    };
    this.setState(newState);
    this.props.handleFetchImageCountry(data);
    this.props.handleClearPreviousReducer();
  };

  handleNameChange = (e) => {
    let state = this.state;
    let newState = { ...state };
    newState.deleteReason = e.target.value;
    this.setState(newState);
  };

  handleRejectionReason = (e) => {
    let newState = { ...this.state };
    newState.rejectionReason = e.target.value;
    this.setState(newState);
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

  handleFilterChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleChangeCategory = (e) => {
    let state = this.state;
    let newState = { ...state };
    newState.category = e.target.value;
    newState.country = "";
    newState.countryCode = "";
    newState.branchId = "";
    newState.activityId = "";
    newState.branchName = "";
    const data = {
      status: state.status,
      category: newState.category,
    };
    this.setState(newState);
    this.props.handleFetchImageCountry(data);
    this.props.handleClearPreviousReducer();
  };

  handleCountryChange = (e) => {
    let state = this.state;
    if (e.target.value !== "Select Country") {
      state.countryCode = e.target.value;
      state.branchId = "";
      state.activityId = "";
      //   state.status = "PENDING";
      const data = {
        countryCode: e.target.value,
        category: state.category,
        status: state.status,
      };
      this.setState({ ...state });
      this.props.handleFetchImageBranch(data);
    }
  };

  handleBranchChange = (e) => {
    let state = this.state;
    if (e.target.value !== "Select Branch") {
      state.branchId = e.target.value;
      this.setState({ ...state });
      let data = {
        category: state.category,
        countryCode: state.countryCode,
        branchId: e.target.value,
      };
      this.props.handleFetchActivityForGallery(data);
    }
  };

  handleActivityChange = (e) => {
    let state = this.state;
    state.activityId = e.target.value;
    this.setState({ ...state });
  };

  handleSubmitFilter = (e) => {
    let state = this.state;
    e.preventDefault();
    let data = {
      countryCode: state.countryCode,
      branchId: state.branchId.toLowerCase().trim(),
      branchName: state.branchName.toLowerCase().trim(),
      status: state.status,
      category: state.category,
      activityId:
        state.activityId !== "Select Activity" ? state.activityId : "",
    };
    state.finalCategory = state.category;
    state.statusForApproveAndReject = state.status;

    this.setState({ ...state });
    this.props.handleFetchImageForModeration(data);
  };

  handleToggleModel = (e, item, slug) => {
    this.setState({
      toggleRejectModal: !this.state.toggleRejectModal,
      imageData: item,
      slugForRejection: slug,
    });
  };

  handleToggleDeleteModel = (e, item) => {
    this.setState({
      toggleDeleteModal: !this.state.toggleDeleteModal,
      imageData: item,
    });
  };

  handleRideSingleImageApproveModeration = (e, item) => {
    let data = {
      status: "APPROVED",
      assetId: item._id,
      rejectionReason: "",
    };
    this.props.handleModerateImage(data);
  };

  handleRideSingleImageDisApproveModeration = (e, item) => {
    let state = this.state;
    let data = {
      status: "REJECTED",
      assetId: state.imageData._id,
      rejectionReason: state.rejectionReason,
    };
    this.props.handleModerateImage(data);
    state.toggleRejectModal = !state.toggleRejectModal;
    state.rejectionReason = "";
    this.setState({ ...state });
  };

  handleRideSingleImageDeletemoderation = (item) => {
    let state = this.state;
    let data = {
      status: "DELETED",
      assetId: state.imageData._id,
      rejectionReason: state.deleteReason,
    };
    this.props.handleModerateImage(data);
    state.toggleDeleteModal = !state.toggleDeleteModal;
    state.deleteReason = "";
    this.setState({ ...state });
  };

  handleRideAllImageApproveModeration = (e, item) => {
    let state = this.state;
    let data = {
      status: "APPROVEALL",
      docId: item._id,
      rejectionReason: "",
    };
    let reqObj = {
      status: this.state.status,
      countryCode: this.state.countryCode,
      branchId: this.state.branchId,
      category: this.state.category,
      activityId: this.state.activityId,
    };
    this.props.handleModerateImage(data, reqObj, "all");
  };

  handleRideAllImageDisApproveModeration = (e, item) => {
    let state = this.state;
    let data = {
      status: "REJECTALL",
      docId: state.imageData._id,
      rejectionReason: state.rejectionReason,
    };
    let reqObj = {
      status: this.state.status,
      countryCode: this.state.countryCode,
      branchId: this.state.branchId,
      category: this.state.category,
      activityId: this.state.activityId,
    };
    this.props.handleModerateImage(data, reqObj, "all");
    state.toggleRejectModal = !state.toggleRejectModal;
    state.rejectionReason = "";

    this.setState({ ...state });
  };

  handlePreviewModal = (e, item) => {
    this.setState({
      previewModal: !this.state.previewModal,
      imageAndRideDetail: item,
    });
    console.log({ item });
    let reqObj = {
      status: this.state.status,
      countryCode: this.state.countryCode,
      branchId: this.state.branchId,
      category: this.state.category,
      activityId: this.state.activityId,
    };
    this.props.handleFetchImageForModeration(reqObj);
  };

  handlePreviewImages = (e, item) => {
    this.setState({
      previewImage: !this.state.previewImage,
      imageDetail: item && item.srcPath,
    });
  };

  handleClearFilter = () => {
    let state = this.state;
    let data = {
      status: "PENDING",
      countryCode: "",
      country: "",
      branchId: "",
      category: "ride",
      activityId: "",
    };

    state.status = "PENDING";
    state.countryCode = "";
    state.country = "";
    state.branchId = "";
    state.category = "ride";
    state.statusForApproveAndReject = "PENDING";
    state.activityId = "";

    this.setState({ ...state });
    this.props.handleFetchImageForModeration(data);
  };

  render() {
    let {
      elements,
      rideImageCountries,
      rideImageBranches,
      rideImagesForModerationStatus,
      rideImagesForModeration,
    } = this.props;
    return (
      <>
        <>
          {rideImagesForModerationStatus !== false ? <Loader /> : null}
          <Form onSubmit={this.handleSubmitFilter}>
            <Row>
              <Col sm={12} className="mobileCenter">
                <CartTitle
                  title={_.get(
                    elements,
                    "imageModerationListingFilterElements.headingElement",
                    "Image Moderation"
                  )}
                  Name={_.get(
                    elements,
                    "imageModerationListingFilterElements.filterButtonElement",
                    "Filter"
                  )}
                  iconClass={"hideexcel"}
                  handleToggle={() => this.handleToggle()}
                  preRegisteredUserCount={this.props.dealerCount}
                />
              </Col>
              <Col sm={12}>
                <Collapse isOpen={this.state.toggleActive}>
                  <Card className="mb-3">
                    <CardBody>
                      <Row>
                        <Col xl={4} lg={4} md={6} sm={6}>
                          <Label className="inputLabel">
                            {_.get(
                              elements,
                              "imageModerationListingFilterElements.categoryLabelElement",
                              "Category"
                            )}
                          </Label>
                          <Input
                            type="select"
                            name="Category"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleChangeCategory}
                            value={this.state.category}
                          >
                            <option value={"ride"}>
                              {_.get(
                                elements,
                                "imageModerationListingFilterElements.selectRideElement",
                                "Ride"
                              )}
                            </option>
                            <option value={"event"}>
                              {_.get(
                                elements,
                                "imageModerationListingFilterElements.selectEventElement",
                                "Event"
                              )}
                            </option>
                          </Input>
                        </Col>

                        <Col xl={4} lg={4} md={6} sm={6}>
                          <FormGroup className=" confirmRiderSelect select_options">
                            <Label className="inputLabel">
                              {_.get(
                                elements,
                                "imageModerationListingFilterElements.countryLabelElement",
                                "Country"
                              )}
                            </Label>
                            <Input
                              type="select"
                              name="City"
                              className="w-100 customeSelectBtn"
                              onChange={this.handleCountryChange}
                              value={this.state.countryCode}
                            >
                              <option>
                                {_.get(
                                  elements,
                                  "imageModerationListingFilterElements.selectCountryLabelElement",
                                  "Select Country"
                                )}
                              </option>
                              {rideImageCountries.map((item, index) => (
                                <option
                                  key={index}
                                  value={item._id.countryCode}
                                >
                                  {item._id.country}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col xl={4} lg={4} md={6} sm={6}>
                          <Label className="inputLabel">
                            {_.get(
                              elements,
                              "imageModerationListingFilterElements.branchLabelElement",
                              "Branch"
                            )}
                          </Label>
                          <FormGroup className=" confirmRiderSelect select_options">
                            <Input
                              type="select"
                              name="Branch"
                              className="w-100 customeSelectBtn"
                              onChange={this.handleBranchChange}
                              value={this.state.branchId}
                            >
                              <option>
                                {this.state.branchName !== ""
                                  ? this.state.branchName
                                  : _.get(
                                      elements,
                                      "imageModerationListingFilterElements.selectBranchLabelElement",
                                      "Select Branch"
                                    )}
                              </option>
                              {rideImageBranches.map((item, index) => (
                                <option key={index} value={item.branchId}>
                                  {item.branchName}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col xl={4} lg={4} md={6} sm={6}>
                          <Label className="inputLabel">
                            {_.get(
                              elements,
                              "imageModerationListingFilterElements.statusLabelElement",
                              "Status"
                            )}
                          </Label>
                          <Input
                            type="select"
                            name="City"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleChangeStatus}
                            value={this.state.status}
                          >
                            <option value={"PENDING"}>
                              {_.get(
                                elements,
                                "imageModerationListingFilterElements.pendingElement",
                                "Pending"
                              )}
                            </option>
                            <option value={"APPROVED"}>
                              {_.get(
                                elements,
                                "imageModerationListingFilterElements.approvedElement",
                                "Approved"
                              )}
                            </option>
                            <option value={"REJECTED"}>
                              {_.get(
                                elements,
                                "imageModerationListingFilterElements.rejectedElement",
                                "Rejected"
                              )}
                            </option>
                          </Input>
                        </Col>

                        <Col xl={4} lg={4} md={6} sm={6}>
                          <Label className="inputLabel">
                            {_.get(
                              elements,
                              "imageModerationListingFilterElements.activityLabelElement",
                              "Activity"
                            )}
                          </Label>
                          <FormGroup className=" confirmRiderSelect select_options">
                            <Input
                              type="select"
                              name="Branch"
                              className="w-100 customeSelectBtn"
                              onChange={this.handleActivityChange}
                              value={this.state.activityId}
                            >
                              <option>
                                {_.get(
                                  elements,
                                  "imageModerationListingFilterElements.selectActivityLabelElement",
                                  "Select Activity"
                                )}
                              </option>
                              {this.props.activityForGallery.map(
                                (item, index) => (
                                  <option key={index} value={item._id}>
                                    {this.state.category === "ride"
                                      ? item.rideName
                                      : item.eventName}
                                  </option>
                                )
                              )}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                        <CustomButton
                          customType={"submit"}
                          name={_.get(
                            elements,
                            "imageModerationListingFilterElements.searchButtonElement",
                            "Search"
                          )}
                          customClass={"btn-outline-dark bg-none btnthemeColor"}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "imageModerationListingFilterElements.clearFilterButtonElement",
                            "Clear Filter"
                          )}
                          customClass={
                            "btn-outline-dark bg-none btnthemeColor ml-2"
                          }
                          customClick={this.handleClearFilter}
                        />
                      </div>
                    </CardBody>
                  </Card>
                </Collapse>
              </Col>
            </Row>
          </Form>

          <Row>
            {rideImagesForModeration.length > 0 ? (
              rideImagesForModeration.map((item) => (
                <Col sm={6} lg={4} xl={3} className="mb-3">
                  <div className="moderationImgContainer">
                    <ImageComponent
                      className={"rounded"}
                      item={item.images.length !== 0 && item.images[0].srcPath}
                      openClick={(e) => this.handlePreviewModal(e, item)}
                      categoryInfo={item.activity}
                      category={this.state.finalCategory}
                      elements={elements}
                    />
                    {this.state.statusForApproveAndReject === "PENDING" ? (
                      <div className="d-flex justify-content-between mt-3">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "imageModerationListingFilterElements.approveAllElement",
                            "Approve All"
                          )}
                          customClass={"btn-outline-dark bg-none btnthemeColor"}
                          customClick={(e) =>
                            this.handleRideAllImageApproveModeration(e, item)
                          }
                        />

                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "imageModerationListingFilterElements.rejectAllElement",
                            "Reject All"
                          )}
                          customClass={
                            "btn-outline-dark bg-none btnthemeColor ml-2"
                          }
                          customClick={(e) =>
                            this.handleToggleModel(e, item, "all")
                          }
                        />
                      </div>
                    ) : null}

                    {this.state.statusForApproveAndReject === "APPROVED" ? (
                      <CustomButton
                        customType={"button"}
                        name={_.get(
                          elements,
                          "imageModerationListingFilterElements.rejectAllElement",
                          "Reject All"
                        )}
                        customClass={"btn-outline-dark bg-none btnthemeColor"}
                        customClick={(e) =>
                          this.handleToggleModel(e, item, "all")
                        }
                      />
                    ) : null}

                    {this.state.statusForApproveAndReject === "REJECTED" ? (
                      <CustomButton
                        customType={"button"}
                        name={_.get(
                          elements,
                          "imageModerationListingFilterElements.approveAllElement",
                          "Approve All"
                        )}
                        customClass={"btn-outline-dark bg-none btnthemeColor"}
                        customClick={(e) =>
                          this.handleRideAllImageApproveModeration(e, item)
                        }
                      />
                    ) : null}
                  </div>
                </Col>
              ))
            ) : (
              <>
                <h2 class="mx-auto">
                  {_.get(
                    elements,
                    "imageModerationListingFilterElements.noImagesToShowElement",
                    "No Images To Show."
                  )}
                </h2>
              </>
            )}
          </Row>
        </>

        <Modal size="xl" centered isOpen={this.state.previewModal}>
          <ModalHeader toggle={this.handlePreviewModal}>
            {_.get(
              elements,
              "imageModerationListingFilterElements.previewLabelElement",
              "Preview"
            )}
          </ModalHeader>
          <ModalBody>
            {this.state.imageAndRideDetail && (
              <React.Fragment>
                <div className="d-flex flex-wrap flex-column flex-xs-row flex-lg-row">
                  {this.state.imageAndRideDetail.images.map((item) => (
                    <div className="d-flex flex-column justify-content-center align-items-center mb-3 w-33">
                      <ImagePreviewComponent
                        className={"rounded"}
                        onClick={(e) => this.handlePreviewImages(e, item)}
                        srcPath={item.srcPath}
                        elements={elements}
                      />
                      {item.moderationStatus === "PENDING" ? (
                        <>
                          <div className="d-flex justify-content-center justify-content-lg-around w-100 mt-3">
                            <CustomButton
                              customType={"button"}
                              name={_.get(
                                elements,
                                "imageModerationListingFilterElements.approveElement",
                                "Approve"
                              )}
                              customClass={
                                "btn-outline-dark bg-none btnthemeColor"
                              }
                              customClick={(e) =>
                                this.handleRideSingleImageApproveModeration(
                                  e,
                                  item
                                )
                              }
                            />
                            <CustomButton
                              customType={"button"}
                              name={_.get(
                                elements,
                                "imageModerationListingFilterElements.rejectElement",
                                "Reject"
                              )}
                              customClass={
                                "btn-outline-dark bg-none btnthemeColor ml-2"
                              }
                              customClick={(e) =>
                                this.handleToggleModel(e, item, "single")
                              }
                            />
                          </div>
                          <div className="d-flex justify-content-center justify-content-lg-around w-100 mt-3">
                            <CustomButton
                              customType={"button"}
                              name={_.get(
                                elements,
                                "imageModerationListingFilterElements.deleteElement",
                                "Delete"
                              )}
                              customClass={
                                "btn-outline-dark bg-none btnthemeColor ml-1"
                              }
                              customClick={(e) =>
                                this.handleToggleDeleteModel(e, item)
                              }
                            />
                          </div>
                        </>
                      ) : null}
                      {item.moderationStatus === "REJECTED" ? (
                        <div className="d-flex justify-content-center justify-content-lg-around w-100 mt-3">
                          <CustomButton
                            customType={"button"}
                            name={_.get(
                              elements,
                              "imageModerationListingFilterElements.approveElement",
                              "Approve"
                            )}
                            customClass={
                              "btn-outline-dark bg-none btnthemeColor"
                            }
                            customClick={(e) =>
                              this.handleRideSingleImageApproveModeration(
                                e,
                                item
                              )
                            }
                          />
                          <CustomButton
                            customType={"button"}
                            name="Delete"
                            customClass={
                              "btn-outline-dark bg-none btnthemeColor ml-2"
                            }
                            customClick={(e) =>
                              this.handleToggleDeleteModel(e, item)
                            }
                          />
                        </div>
                      ) : null}
                      {item.moderationStatus === "APPROVED" ? (
                        <div className="d-flex justify-content-center justify-content-lg-around w-100 mt-3">
                          <CustomButton
                            customType={"button"}
                            name={_.get(
                              elements,
                              "imageModerationListingFilterElements.rejectElement",
                              "Reject"
                            )}
                            customClass={
                              "btn-outline-dark bg-none btnthemeColor"
                            }
                            customClick={(e) =>
                              this.handleToggleModel(e, item, "single")
                            }
                          />
                          <CustomButton
                            customType={"button"}
                            name="Delete"
                            customClass={
                              "btn-outline-dark bg-none btnthemeColor ml-2"
                            }
                            customClick={(e) =>
                              this.handleToggleDeleteModel(e, item)
                            }
                          />
                        </div>
                      ) : null}
                    </div>
                  ))}
                </div>

                <Row className="mt-4">
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "imageModerationListingFilterElements.hastagElement",
                        "Hashtag"
                      )}
                      titleName={this.state.imageAndRideDetail.hashtag.map(
                        (item) => item
                      )}
                    />
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "imageModerationListingFilterElements.activityNameElement",
                        "Activity Name"
                      )}
                      titleName={
                        this.state.imageAndRideDetail.activity &&
                        this.state.imageAndRideDetail.activity.category ===
                          "event"
                          ? this.state.imageAndRideDetail.activity &&
                            this.state.imageAndRideDetail.activity.categoryId &&
                            this.state.imageAndRideDetail.activity.categoryId
                              .eventName
                          : this.state.imageAndRideDetail.activity &&
                            this.state.imageAndRideDetail.activity.categoryId &&
                            this.state.imageAndRideDetail.activity.categoryId
                              .rideName
                      }
                    />
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "imageModerationListingFilterElements.countryElement",
                        "Country"
                      )}
                      titleName={
                        this.state.imageAndRideDetail.activity &&
                        this.state.imageAndRideDetail.activity.category ===
                          "event"
                          ? this.state.imageAndRideDetail.activity.categoryId &&
                            this.state.imageAndRideDetail.activity.categoryId
                              .eventInfo &&
                            this.state.imageAndRideDetail.activity.categoryId
                              .eventInfo.country
                          : this.state.imageAndRideDetail.activity &&
                            this.state.imageAndRideDetail.activity.categoryId &&
                            this.state.imageAndRideDetail.activity.categoryId
                              .rideInfo &&
                            this.state.imageAndRideDetail.activity.categoryId
                              .rideInfo.country
                      }
                    />
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "imageModerationListingFilterElements.stateElement",
                        "State"
                      )}
                      titleName={
                        this.state.imageAndRideDetail.activity &&
                        this.state.imageAndRideDetail.activity.category ===
                          "event"
                          ? this.state.imageAndRideDetail.activity.categoryId &&
                            this.state.imageAndRideDetail.activity.categoryId
                              .eventInfo &&
                            this.state.imageAndRideDetail.activity.categoryId
                              .eventInfo.state
                          : this.state.imageAndRideDetail.activity &&
                            this.state.imageAndRideDetail.activity.categoryId &&
                            this.state.imageAndRideDetail.activity.categoryId
                              .rideInfo &&
                            this.state.imageAndRideDetail.activity.categoryId
                              .rideInfo.state
                      }
                    />
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "imageModerationListingFilterElements.nameElement",
                        "Name"
                      )}
                      titleName={`${this.state.imageAndRideDetail.uploadedBy &&
                        this.state.imageAndRideDetail.uploadedBy.userId &&
                        this.state.imageAndRideDetail.uploadedBy.userId.fName} 

                        ${this.state.imageAndRideDetail.uploadedBy &&
                          this.state.imageAndRideDetail.uploadedBy.userId &&
                          this.state.imageAndRideDetail.uploadedBy.userId
                            .lName}`}
                    />
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "imageModerationListingFilterElements.emailElement",
                        "Email"
                      )}
                      titleName={
                        this.state.imageAndRideDetail.uploadedBy &&
                        this.state.imageAndRideDetail.uploadedBy.userId &&
                        this.state.imageAndRideDetail.uploadedBy.userType ===
                          "brandUser"
                          ? this.state.imageAndRideDetail.uploadedBy.userId
                              .contact &&
                            this.state.imageAndRideDetail.uploadedBy.userId
                              .contact.email
                          : this.state.imageAndRideDetail.uploadedBy.userId
                              .contactDetails &&
                            this.state.imageAndRideDetail.uploadedBy.userId
                              .contactDetails.email
                      }
                    />
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "imageModerationListingFilterElements.branchNameElement",
                        "Branch Name"
                      )}
                      titleName={
                        this.state.imageAndRideDetail.activity &&
                        this.state.imageAndRideDetail.activity.categoryId &&
                        this.state.imageAndRideDetail.activity.categoryId
                          .createdBy &&
                        this.state.imageAndRideDetail.activity.categoryId
                          .createdBy.branchName
                      }
                    />
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "imageModerationListingFilterElements.branchCodeElement",
                        "Branch Code"
                      )}
                      titleName={
                        this.state.imageAndRideDetail.activity &&
                        this.state.imageAndRideDetail.activity.categoryId &&
                        this.state.imageAndRideDetail.activity.categoryId
                          .createdBy &&
                        this.state.imageAndRideDetail.activity.categoryId
                          .createdBy.branchCode
                      }
                    />
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "imageModerationListingFilterElements.updatedOnElement",
                        "Updated On"
                      )}
                      titleName={moment(
                        this.state.imageAndRideDetail.updatedAt
                      ).format("DD-MM-YYYY")}
                    />
                  </Col>
                  <Col xl={12} lg={12} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "imageModerationListingFilterElements.descriptionElement",
                        "Description"
                      )}
                      titleName={this.state.imageAndRideDetail.description}
                    />
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </ModalBody>
        </Modal>

        <Modal size="xl" centered isOpen={this.state.previewImage}>
          <ModalHeader toggle={this.handlePreviewImages}></ModalHeader>
          <ModalBody>
            <div className="slider">
              <Slider {...settings}>
                {this.state.imageAndRideDetail &&
                  this.state.imageAndRideDetail.images.map((item) => (
                    <div>
                      <img
                        src={`${config.imageBaseUrl}${item.srcPath}`}
                        alt=""
                        className="w-100 preview_InnerImage"
                      />
                    </div>
                  ))}
              </Slider>
            </div>
          </ModalBody>
        </Modal>

        <Modal centered isOpen={this.state.toggleRejectModal}>
          <ModalHeader toggle={this.handleToggleModel}>
            {_.get(
              elements,
              "rideDetailElement.rejectionReasonElement",
              "Rejection Reason"
            )}
          </ModalHeader>
          <ModalBody>
            <InputText
              inputType={"textarea"}
              inputName={"rejectionReason"}
              customValue={this.state.rejectionReason}
              customOnChange={(e) => this.handleRejectionReason(e)}
            />
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name={_.get(
                elements,
                "rideDetailElement.rejectButtonElement",
                "Reject"
              )}
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={
                this.state.slugForRejection !== "all"
                  ? (e) => this.handleRideSingleImageDisApproveModeration(e)
                  : (e) => this.handleRideAllImageDisApproveModeration(e)
              }
            />
          </ModalFooter>
        </Modal>

        <Modal centered isOpen={this.state.toggleDeleteModal}>
          <ModalHeader toggle={this.handleToggleDeleteModel}>
            Delete Reason
          </ModalHeader>
          <ModalBody>
            <tbody>
              <tr>
                <td>
                  <input
                    type="checkbox"
                    name="Invalid"
                    value="Invalid"
                    checked={this.state.deleteReason === "Invalid"}
                    onChange={(e) => this.handleNameChange(e)}
                  />
                  <span className="ml-2">Invalid</span>
                </td>
              </tr>
              <tr>
                <td>
                  <input
                    type="checkbox"
                    name="Offensive"
                    value="Offensive"
                    checked={this.state.deleteReason === "Offensive"}
                    onChange={(e) => this.handleNameChange(e)}
                  />
                  <span className="ml-2">Offensive</span>
                </td>
              </tr>
              <tr>
                <td>
                  <input
                    type="checkbox"
                    name="Blur"
                    value="Blur"
                    checked={this.state.deleteReason === "Blur"}
                    onChange={(e) => this.handleNameChange(e)}
                  />
                  <span className="ml-2">Blur</span>
                </td>
              </tr>
            </tbody>
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name="Delete"
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={(e) => this.handleRideSingleImageDeletemoderation(e)}
            />
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
